import type {
  ResetPasswordDraft,
  ResetPasswordError,
  SubmitStatus,
} from '../domain/reset-password.model';

/**
 * Redux state for the Reset Password form: the editable draft, per-field
 * validation errors, the submit lifecycle, and the last business error. The
 * one-time token is NOT here; the URL stays its single source of truth (the
 * page reads it and passes it in the signal action's payload), so no stale token
 * ever lingers in the store. `showPassword` is a pure display toggle and lives
 * as local state in the view. Every field is serialisable.
 */
export interface ResetPasswordState {
  draft: ResetPasswordDraft;
  validationErrors: Record<string, string>;
  status: SubmitStatus;
  error: ResetPasswordError | null;
}

export const emptyDraft: ResetPasswordDraft = { password: '', confirmPassword: '' };

export const initialState: ResetPasswordState = {
  draft: emptyDraft,
  validationErrors: {},
  status: 'idle',
  error: null,
};
